import React from 'react';

export default function IconFundachart() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6734 2.6665H2.34009C1.78675 2.6665 1.34009 3.11317 1.34009 3.6665V12.3332C1.34009 12.8865 1.78675 13.3332 2.34009 13.3332H13.6734C14.2268 13.3332 14.6734 12.8865 14.6734 12.3332V3.6665C14.6734 3.11317 14.2268 2.6665 13.6734 2.6665Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.15991 10.4263L4.92658 8.17959C5.05325 8.01959 5.28658 8.00626 5.42658 8.15292L6.85991 9.60626C7.01325 9.75959 7.27325 9.73292 7.37991 9.54626L8.82658 7.13959C8.94658 6.93959 9.23325 6.91959 9.37991 7.11292L10.6799 8.83959C10.8266 9.03959 11.1332 9.00626 11.2466 8.78626L12.8466 5.57959"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
